module.exports = __webpack_public_path__ + "static/img/about-certificate-01.b40f2da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-01.jpg
// module id = V5gR
// module chunks = 1